import ClientReportScreen from './ClientReportScreen.js';

export default ClientReportScreen;